import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { DatePickerValidationError } from "../enums/DatePickerValidationError";
import {
  DatePickerInput,
  InvalidDateError,
} from "@surya-digital/leo-reactjs-material-ui";
import { LeoDate } from "@surya-digital/leo-ts-runtime";
import {
  getLocalDateString,
  getStartOfToday,
  parseLocalDateString,
} from "../utils/DateUtils";

export const DatePickerModel = types
  .model("DatePicker", {
    dateString: types.maybe(types.string),
    validationError: types.maybe(
      types.enumeration(
        "DatePickerValidationError",
        Object.values(DatePickerValidationError),
      ),
    ),
  })
  .views((store) => ({
    get date(): DatePickerInput | null {
      return store.dateString ? parseLocalDateString(store.dateString) : null;
    },
  }))
  .views((store) => ({
    get rpcObject(): LeoDate {
      return new LeoDate(store.dateString);
    },
  }))
  .actions((store) => ({
    setError: (error: InvalidDateError | null): void => {
      if (error) {
        store.validationError = DatePickerValidationError.InvalidDate;
      } else if (
        store.validationError !== DatePickerValidationError.EmptyDate
      ) {
        store.validationError = undefined;
      }
    },
    setDate: (date: DatePickerInput): void => {
      store.dateString = date ? getLocalDateString(date) : undefined;

      if (!date) {
        store.validationError = DatePickerValidationError.EmptyDate;
      } else if (
        store.validationError === DatePickerValidationError.EmptyDate
      ) {
        store.validationError = undefined;
      }
    },
    resetError: (): void => {
      store.validationError = undefined;
    },
  }));

export const createDatePickerModel = (
  date?: SnapshotIn<typeof DatePickerModel>,
): Instance<typeof DatePickerModel> =>
  DatePickerModel.create(
    date ?? { dateString: getLocalDateString(getStartOfToday()) },
  );
